module.exports = __webpack_public_path__ + "img/wlv_21.4b656777.png";